/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_ToggleInputs */



/**
* | output |
* | --- |
* | "Export a segment only" |
*
* @param {Video_Export_Segment_ToggleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_toggle = /** @type {((inputs?: Video_Export_Segment_ToggleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_ToggleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter un segment uniquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur ein Segment exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta solo un segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт только сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar solo un segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅导出片段")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントのみをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल एक खंड निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar apenas um segmento")
	return /** @type {LocalizedString} */ ("Export a segment only")
});